module.exports = __webpack_public_path__ + "img/modal-red.eba46893.svg";